<template>
  <div>
    <el-dialog v-dialogDrag :title="title" :visible.sync="isDialog" width="700px" @opened="initData" @close="clearFun('menu')" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form size="small" :model="menu" ref="menu" :rules="rules" label-width="95px">
        <el-form-item prop="id" style="display:none;">
          <el-input v-model="menu.id"/>
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="编码：" prop="code">
              <el-input v-model="menu.code"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="名称：" prop="name">
              <el-input v-model="menu.name"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="路径：" prop="url">
              <el-input v-model="menu.url"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="菜单分类：" prop="type">
              <el-select v-model="menu.type" clearable placeholder="请选择菜单分类" class="width-full">
                <el-option v-for="item in menuTypes" :key="item.value" :value="parseInt(item.value)" :label="item.name"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="图标：" prop="icon">
              <el-input v-model="menu.icon"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="图标分类：" prop="iconType">
              <el-select v-model="menu.iconType" clearable placeholder="请选择图标分类" class="width-full">
                <el-option v-for="item in iconTypes" :key="item.value" :value="parseInt(item.value)" :label="item.name"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="父级：" prop="parentId">
              <el-cascader v-model="menu.parentId" :options="menus" :props="{value:'id',label:'name',checkStrictly:true,emitPath:false}" :show-all-levels="false" placeholder="请选择父级" class="width-full" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="排序：" prop="sort">
              <el-input v-model="menu.sort" placeholder="输入大于等于0的数字" maxlength="11" oninput="value=value.replace(/[^\d]/g,'')"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注：" prop="remark">
              <el-input type="textarea" v-model="menu.remark" maxlength="250" placeholder="请输入内容" rows="3" show-word-limit/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button @click="isDialog = false" size="small">取消</el-button>
        <el-button type="primary" size="small" @click="submitFun('menu')">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'AddOrUpdate',
  props: {
    //列表刷新
    refresh: {
      type: Function
    }
  },
  data() {
    return {
      //标题
      title: '新增',
      //是否打开弹窗
      isDialog: false,
      //数据
      menu: {
        iconType: 0
      },
      //验证规则
      rules: {
        code: [{
          required: true,
          message: '请输入编码',
          trigger: 'blur'
        }],
        name: [{
          required: true,
          message: '请输入名称',
          trigger: 'blur'
        }],
        url: [{
          required: true,
          message: '请输入菜单路径',
          trigger: 'blur'
        }],
        type: [{
          required: true,
          message: '请选择菜单分类',
          trigger: 'change'
        }]
      },
      //父级数据选择
      menus: [],
      //菜单分类
      menuTypes: [],
      //图标分类
      iconTypes: []
    }
  },
  methods: {
    //提交
    submitFun: function(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          //数据提交保存
          this.$axios({
            method: 'post',
            url: '/sysMenu/saveOrUpdate',
            data: this.menu
          }).then(response => {
            this.refresh()
            this.isDialog = false
            this.$message.success('保存成功~')
          })
        } else {
          return false;
        }
      });
    },
    //清除表单数据
    clearFun: function(formName){
      this.$refs[formName].resetFields()
      this.menu = {
        iconType: 0
      }
    },
    //初始化下拉选择数据
    initData: function(){
      //父级菜单数据
      this.$axios.get('/sysMenu/getAll').then(response => {
        this.menus = this.$utils.convertTree(response)
      })
      //菜单分类
      this.$axios.get('/sysConfig/selectByPcode', {
        params: {
          pcode: 'menu_type'
        }
      }).then(response => {
        this.menuTypes = response
      })
      //图标分类
      this.$axios.get('/sysConfig/selectByPcode', {
        params: {
          pcode: 'icon_type'
        }
      }).then(response => {
        this.iconTypes = response
      })
    }
  }
}
</script>

<style scoped>
  .width-full {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/system/menu/AddOrUpdate.vue